import {
  styled,
  Typography,
  tableRowClasses,
  tableCellClasses,
} from '@mui/material';

import { DashboardZoneSaturationZone } from '~services/dashboard/types';
import Table from '~components/Table';
import { TableProps } from '~components/Table/types';

export const DashboardVariantV2CarrierZoneSaturationCollapseTableContentEmptyText =
  styled(Typography)(({ theme }) => ({
    padding: theme.spacing(4),
    textAlign: 'center',
    color: theme.palette.text.secondary,
  }));

export const DashboardVariantV2CarrierZoneSaturationCollapseTableContentTable =
  styled((props: TableProps<DashboardZoneSaturationZone>) => (
    <Table {...props} />
  ))(({ theme }) => ({
    [`& .${tableRowClasses.root} .${tableCellClasses.root}`]: {
      fontSize: theme.typography.caption.fontSize,
      letterSpacing: 0.5,
      color: theme.palette.text.secondary,
    },

    [`& .${tableRowClasses.root} .${tableCellClasses.head}`]: {
      borderWidth: `1px !important`,
      textTransform: 'uppercase',
      fontWeight: theme.typography.fontWeightBold,
    },

    [`& .${tableRowClasses.root}:last-of-type .${tableCellClasses.body}`]: {
      borderBottom: 'none !important',
    },
  }));
